"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _classnames = _interopRequireDefault(require("classnames"));
var _reactDeviceDetect = require("react-device-detect");
const WhatsAppShareButton = _ref => {
  let whatsappText = _ref.whatsappText;
  const baseUrl = _reactDeviceDetect.isMobile ? 'whatsapp://' : 'https://api.whatsapp.com/';
  return /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _classnames.default)('btn white h3 p3 col-12 caps h5 rounded border-box'),
    href: "".concat(baseUrl, "send?text=").concat(encodeURIComponent(whatsappText)),
    style: {
      backgroundColor: '#4CEC68',
      color: '#fff'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "share.components--whatsapp-share-button.text",
    defaultMessage: "Compartilhar no WhatsApp"
  }));
};
var _default = exports.default = WhatsAppShareButton;